<template>
  <div class="flexing flex-col w-full">
    <div class="w-full p-6 space-y-6">
      <h1
        class="font-medium text-36"
        :class="isError ? 'text-texts-standard-danger' : 'text-texts-standard-important'"
      >
        <template v-if="isError">Error</template>
        <template v-else>{{ $t('settings.passwordChanged') }}</template>
      </h1>
      <p class="text-texts-standard-default text-28 font-medium py-8">
        <template v-if="isError">E-mail could not be sent. Please try again later.</template>
        <template v-else>
          {{ $t('homepage.passwordChangedInfo') }}
        </template>
      </p>
      <app-button v-if="isError" type="submit" btn-type="confirm" @click="$emit('back')">
        {{ $t('homepage.back') }}
        <component-loading class="absolute inset-0" :is-loading="isLoading" />
      </app-button>
      <app-button v-else type="submit" btn-type="confirm" @click="$emit('login')">
        {{ $t('homepage.loginBtn') }}
        <component-loading class="absolute inset-0" :is-loading="isLoading" />
      </app-button>
    </div>
  </div>
</template>

<script lang="ts">
import ComponentLoading from '../GlobalComponents/ComponentLoading.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    ComponentLoading,
  },
  props: {
    isError: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['back', 'login'],
})
</script>
